import React, { useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import CountdownTimer from "../../../components/countdownTimer";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import Button from "../../../forms/button";
import { attributes, Theme } from "../../../theme";
import Share from "../../../components/share";
import CopyableText from "../../../components/copyableText";

const RunningGame = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { name, game, gameId, action, handleQuit } = props;

  if (action) {
    return (
      <Theme>
        <View style={styles.container}>
          <View style={styles.gameIdContainer}>
            <CopyableText
              value={gameId}
              textStyles={{ ...styles.targetText, color: "black" }}
            />
            <View style={styles.shareContainer}>
              <Share gameId={gameId} />
            </View>
          </View>
          <View style={styles.text}>
            <Text style={styles.targetText}>{action.target.name}</Text>
            <Text style={styles.displayText}>{action.display}</Text>
            <Text style={styles.targetText}>{action.drink}</Text>
          </View>

          <View style={styles.countdown}>
            <CountdownTimer
              key={action.id}
              length={action.lengthInSeconds}
              nextEvent={action.nextEvent}
            />
          </View>
          <View style={styles.buttonContainer}>
            <Button
              raised={false}
              title="Quit"
              disabled={isSubmitting}
              buttonStyle={styles.button}
              titleStyle={styles.buttonText}
              onPress={() =>
                handleQuit({
                  id: game.id,
                  name,
                  quitGameRequest: props.quitGame,
                  setIsSubmitting,
                  navigate: props.navigation.navigate,
                })
              }
            />
          </View>
        </View>
      </Theme>
    );
  }

  return (
    <Theme>
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        <Text>
          Game {game.id} has been started {name}.
        </Text>
      </View>
    </Theme>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  targetText: {
    color: attributes.mainColor,
    fontWeight: "bold",
    fontSize: 24,
    textAlign: "center",
  },
  displayText: {
    textAlign: "center",
  },
  text: {
    margin: 20,
    textAlign: "center",
  },
  gameIdContainer: {
    textAlign: "center",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    width: "100%",
    fontWeight: "bold",
  },
  countdown: {
    marginTop: 50,
  },
  buttonContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 25,
  },
  shareContainer: {
    position: "relative",
    bottom: 10,
    left: 10,
  },
  button: {
    backgroundColor: attributes.mainColor,
    width: 100,
  },
  buttonText: {
    color: attributes.backgroundColor,
    fontSize: 24,
  },
});

const QUIT_GAME_MUTATION = gql`
  mutation createJoinGameMutation($id: String!, $name: String!) {
    quitGame(id: $id, name: $name)
  }
`;

const RunningGameWithMutation = graphql(QUIT_GAME_MUTATION, {
  name: "quitGame",
})(RunningGame);

export default RunningGameWithMutation;
